import React from 'react';

import AttributesGroupIcon, {
	AttributesGroupIconType,
} from '~/components/patterns/icons/AttributesGroupIcon';
import BorderedBox from '~/components/patterns/boxes/BorderedBox';
import ColumnCategoryName from '~/components/names/ColumnCategoryName';
import FlexibleBlocks from '~/components/patterns/structures/FlexibleBlocks';
import PageFieldStatisticsChart from './PageFieldStatisticsChart';
import {
	type PagesColumnsCategory
} from '~/model/pagesColumns';
import type CK from '~/types/contentking';



const icons = {
	content: AttributesGroupIconType.Content,
	conversions: AttributesGroupIconType.Conversions,
	fundamentals: AttributesGroupIconType.Fundamentals,
	indexability: AttributesGroupIconType.Indexability,
	lighthouse: AttributesGroupIconType.Lighthouse,
	relations: AttributesGroupIconType.Relations,
	social: AttributesGroupIconType.Social,
} as const;

interface PageAttributesCategoryBoxProps {
	category: PagesColumnsCategory;
	categoryColumns: ReadonlyArray<CK.PagesColumn>;
	filter: unknown;
	websiteId: CK.WebsiteId;
}

function PageAttributesCategoryBox(props: PageAttributesCategoryBoxProps) {
	const {
		category,
		categoryColumns,
		filter,
		websiteId,
	} = props;

	if (categoryColumns.length === 0) {
		return null;
	}

	return (
		<BorderedBox
			headerIcon={(
				<AttributesGroupIcon
					size={28}
					type={icons[category]}
				/>
			)}
			headerLabel={(
				<ColumnCategoryName columnCategory={category} />
			)}
			paddingSize={3}
		>
			<FlexibleBlocks blockMinWidth={300}>
				{categoryColumns.map((column) => (
					<PageFieldStatisticsChart
						column={column}
						filter={filter}
						key={column}
						websiteId={websiteId}
					/>
				))}
			</FlexibleBlocks>
		</BorderedBox>
	);
}

export default PageAttributesCategoryBox;
